__turbopack_context__.v({
  "flag": "FlagIcon-module__NkgCnG__flag",
});
